export default {
    "POST": {
        "POST": "Bejegyzés",
        "SLUG": "URL",
        "TITLE": "Cím",
        "CONTENT": "Tartalom",
        "COLOR": "Szín",
        "CATEGORY": "Kategória",
        "CATEGORIES": "Kategóriák",
        "EXCERPT": "Kivonat",
        "CATEGORY_NAME": "Kategória név",
        "ADDRESS": "Cím",
        "PHONE": "Telefon",
        "MAIL": "Email",
        "ORDER": "Rendezés",
        "PINNED": "Kiemelt",
        "PUBLISH": "Közzétesz",
        "UNPUBLISH": "Visszavon",
        "SCHEDULE_AT": "Időzítés",
        "CREATED_AT": "Dátum",
        "IS_FOOTER": "Footeren",
        "POST_TAG": "Hír kategória",
    }
}



// WEBPACK FOOTER //
// ./src/i18n/messages/hu/post.js